import React from "react"

const Chip = ({ label, value, tone = "neutral" }) => {
  const toneClasses = {
    neutral: "text-admin_text_secondary border-admin_bordered bg-admin_canvas",
    success: "text-admin_success border-admin_success/40 bg-admin_success/10",
    warning: "text-admin_warning border-admin_warning/40 bg-admin_warning/10",
    error: "text-admin_error border-admin_error/40 bg-admin_error/10",
  }
  return (
    <span
      className={`inline-flex items-center gap-1 text-[11px] font-semibold px-2 py-0.5 rounded-full border whitespace-nowrap ${toneClasses[tone] || toneClasses.neutral}`}
    >
      {label && <span className="opacity-70">{label}</span>}
      <span className="font-mono">{value}</span>
    </span>
  )
}

// "Current" state is the most-recent non-null bucket value — not the window
// average. Window average is shown separately as the uptime chip.
const currentValue = (status) => {
  const h = Array.isArray(status?.history) ? status.history : []
  for (let i = h.length - 1; i >= 0; i--) {
    const v = h[i]?.value
    if (typeof v === "number") return v
  }
  return typeof status?.uptime === "number" ? status.uptime : null
}

const StatusChips = ({ status }) => {
  if (!status) return null
  if (!status.ok) {
    return <Chip label="status" value={status.error || "down"} tone="error" />
  }

  const current = currentValue(status)
  const tone =
    current == null ? "neutral" : current >= 0.999 ? "success" : current >= 0.8 ? "warning" : "error"
  const stateLabel =
    current == null
      ? "Unknown"
      : current >= 0.999
      ? "Operational"
      : current >= 0.8
      ? "Degraded"
      : "Down"

  return (
    <div className="flex items-center gap-1.5 flex-wrap">
      <Chip value={stateLabel} tone={tone} />
      {status.uptimePct != null && (
        <Chip label="uptime" value={`${status.uptimePct}%`} />
      )}
      {status.avgLatencyMs != null && (
        <Chip label="latency" value={`${status.avgLatencyMs}ms`} />
      )}
    </div>
  )
}

export default StatusChips
